export const AUTH_STATUS_EVENT = 'folio:auth-status';
export const AUTH_STATUS_CLEAR_EVENT = 'folio:auth-status-clear';
export const SESSION_EXPIRED_EVENT = 'folio:session-expired';
export const PERMISSION_DENIED_EVENT = 'folio:permission-denied';

const publicPortfolioDataRoutes = [
    /^\/data\/ownDomain$/,
    /^\/data\/portfolio(?:\/|$)/,
    /^\/data\/shortid(?:\/|$)/,
];

const nonBlockingApiRoutes = [
    /^\/api\/notifications(?:\/|$)/,
];

function requestPath(url) {
    try {
        return new URL(url, window.location.origin).pathname;
    } catch (e) {
        return String(url).split('?')[0];
    }
}

export function suppressAuthStatusForRequest(url) {
    if (!url) {
        return false;
    }

    const path = requestPath(url);
    return [...publicPortfolioDataRoutes, ...nonBlockingApiRoutes]
        .some((route) => route.test(path));
}

export function publishAuthStatus(detail) {
    window.__uxfolioAuthStatus = detail;
    window.dispatchEvent(new CustomEvent(AUTH_STATUS_EVENT, { detail }));
}

export function clearAuthStatus() {
    window.__uxfolioAuthStatus = null;
    window.dispatchEvent(new CustomEvent(AUTH_STATUS_CLEAR_EVENT));
}

export function publishSessionExpired(detail = {}) {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail }));
}

export function publishPermissionDenied(detail = {}) {
    window.dispatchEvent(new CustomEvent(PERMISSION_DENIED_EVENT, { detail }));
}
